import { Component, Inject } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { UserService } from '../../providers/user.service';
import { IUserListResponse } from '../../../typings/api';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { size, keys, each, map, find } from 'lodash';
import { PlanningService } from '../../providers/planning.service';
import { IPlanningUser } from '../../../typings/timetracker/timetracker';

@Component({
  selector: 'invite-users-dialog',
  templateUrl: 'invite-users-dialog.html'
})
export class InviteUsersDialogComponent {

  public users$: Observable<IUserListResponse>;
  scheduled: { [ key: number ]: boolean; } = {};
  nrOfUsersScheduled: number = 0;

  toggleScheduled() {

    for( var key in this.scheduled ){
      if( this.scheduled.hasOwnProperty( key ) && this.scheduled[ key ] === false ) {
       delete this.scheduled[ key ];
      }
    }
    this.nrOfUsersScheduled = size( keys( this.scheduled ) );
  }

  inviteAndClose() {

    this.data.currentPlanning$.take( 1 ).subscribe( ( planning ) => {
      if ( planning ) {

        const planningUsers = ( map( keys( this.scheduled ), ( keyString ) =>  { return {
          'user_id': parseInt( keyString, 10 )
        } } ) as IPlanningUser[]  );

        // Delete user who are not part of the planning anymore
        //
        this.data.currentUsers$.take( 1 ).subscribe( ( users ) => {
          console.log( planningUsers, users );
          each( users, ( user ) => {
            if ( !find( planningUsers, planningUser => planningUser.user_id ===  user.user_id  ) ) {
              this.$planningAPI.dispatchRemoveUserFromPlanning( planning.id, user.user_id );
            }
          } );
        } );

        this.$planningAPI.dispatchAddUsersToPlanning( planning.id, planningUsers )
        .then( ( response ) => {
          this.dialogRef.close();
        } )
        .catch( ( error ) => {
          console.error( '[PLANING-DETAILS] Invite users', error );
        } );
      }
    } );
  }

  constructor(
    private $userAPI: UserService,
    private $planningAPI: PlanningService,
    public dialogRef: MatDialogRef<InviteUsersDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any ) {

      this.data.currentUsers$.take( 1 ).subscribe( ( users) => {
        each( users, ( user ) => {
          this.scheduled[ user.user_id ] = true;
        } );
      } );

      this.toggleScheduled();

      this.users$ = this.$userAPI.selectUserFetchAll();
      this.$userAPI.dispatchUserFetchAll( 1000, 0 );
  }
}



// WEBPACK FOOTER //
// ./src/components/invite-users-dialog/invite-users-dialog.ts